import { avisar } from "../../../shared/ui/dialogos-api";

/** Abre dialogo de impressao (salvar como PDF) do painel visivel. */
export async function exportarDashboardPdf(
  refPainel: HTMLElement | null,
): Promise<void> {
  if (!refPainel) return;
  const vazio = refPainel.dataset.vazio === "true";
  if (vazio) {
    await avisar({
      titulo: "Sem dados para exportar",
      descricao:
        "O painel está vazio. Publique conteúdos ou ajuste o período e tente de novo.",
    });
    return;
  }
  refPainel.classList.add("dashboard-imprimindo");
  window.print();
  refPainel.classList.remove("dashboard-imprimindo");
}
